import Vue from "vue";
import Component from "vue-class-component";
import { Order } from "@/types/order";
import { Prop, Emit } from "vue-property-decorator";
import { Client } from "@/api/profile";
import REQ_URL from "@/consts/req-url";

@Component({})
export default class OrderElementAbstract extends Vue {
  loading = false;
  @Prop() order!: Order;
  @Prop({ default: false }) showFIO!: boolean;
  @Emit() repeatComplete() {
    return this.order.UniqueNumber;
  }
  get needSetProfile() {
    return (
      !this.$store.state.profile.clientInfo.c1code ||
      this.$store.state.profile.clientInfo.fio !== this.order.Получатель
    );
  }
  onChangeSelectedOrder() {
    if (this.$route.params.id !== this.order.UniqueNumber)
      this.$router.push({
        name: this.$route.params.cid ? "clientOrderDetail" : "orderDetail",
        params: {
          id: this.order.UniqueNumber,
        },
      });
  }
  async repeatOrder() {
    this.loading = true;
    try {
      let data = await this.$fetch<Order>(
        `${REQ_URL.GET_ORDER}?id=${this.order.UniqueNumber}`
      );
      if (data.body)
        data.body.cart.forEach((orderProduct) => {
          orderProduct.quantity = +orderProduct.Количество;
          this.$store.dispatch("addProductToBasket", {
            product: orderProduct,
            quiet: true,
          });
        });
      else throw new Error(data.error);
    } catch (error) {
      console.log(error);
      return false;
    }
    this.loading = false;
    if ((document as any).activeElement) (document as any).activeElement.blur();
    this.repeatComplete();
  }
  /*async setProfileAndRepeat() {
        this.loading = true;
        try {
            let data = await this.$fetch<Client>(REQ_URL.GET_CLIENT_BY_FIO, {
                method: 'POST',
                body: JSON.stringify({
                    id: this.order.Получатель
                })
            })
            if (data.body) {
                this.$store.dispatch('setManagerClientProfile', data.body)
                this.repeatOrder()
            }
            else throw new Error(data.error ? data.error : 'Ошибка соединения. Повторите позже.')
        } catch (error) {
            this.$store.commit('modal:open', { type: 'error', msg: error.message })
            console.error(error)
        }
        this.loading = false;
    }*/
}
